var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length > 0)?_c('ul',{class:{ 'alert-danger': _vm.alert }},_vm._l((_vm.errors),function(error,i){return _c('li',{key:`error-${i}`,staticClass:"error-item"},[_vm._v(" "+_vm._s(_vm.getText(error))+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }